// src/pages/Confidentialite.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function Confidentialite() {
  const { t } = useTranslation();
  return (
    <main className="legal-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('privacy.heroLabel')}</span>
          <h1 className="page-hero__title">{t('privacy.heroTitle')}</h1>
        </div>
      </header>
      <section className="legal-content">
        <h2>{t('privacy.s1Title')}</h2>
        <p>{t('privacy.s1Text')}</p>

        <h2>{t('privacy.s2Title')}</h2>
        <p>{t('privacy.s2Text')}</p>
        <ul>
          <li>{t('privacy.s2List1')}</li>
          <li>{t('privacy.s2List2')}</li>
          <li>{t('privacy.s2List3')}</li>
        </ul>

        <h2>{t('privacy.s3Title')}</h2>
        <p>{t('privacy.s3Text')}</p>

        <h2>{t('privacy.s4Title')}</h2>
        <p>{t('privacy.s4Text')}</p>

        <h2>{t('privacy.s5Title')}</h2>
        <p>{t('privacy.s5Text')}</p>
      </section>
    </main>
  );
}

export default Confidentialite;